"use client"
import style from '@/assets/styling/scss/input.module.scss';
import React, { FC } from 'react';
import { FormattedMessage } from "@/components/elements";
import { translate } from "@/assets/utils/utils";
import { globalStore } from "@/app/stores";
import { observer } from 'mobx-react';

interface TextAreaProps {
  name: any;
  labelId: string;
  placeholderId: string;
  error?: string;
  fullWidth: boolean;
}

const TextArea: FC<TextAreaProps> = observer(({ name, labelId, placeholderId, error, fullWidth }) => {
  const { lang } = globalStore;

  if (!lang) {
    return null;
  }

  const placeholder = translate(lang, placeholderId);

  return (
    <div className={style.textAreaWrapper} style={fullWidth ? { gridColumn: '1/-1' } : undefined}>
      <label className={style.label}>
        <FormattedMessage id={labelId} />
      </label>

      <div className={style.inputContainer}>
        <textarea
          {...name}
          className={style.textarea}
          placeholder={placeholder}
        />
      </div>

      {error && <p className={style.error}>{error}</p>}
    </div>
  );
});

export default TextArea;
